import {Outlet} from 'react-router-dom'

const VouchersPageLayout = () => <><Outlet /></>

export default VouchersPageLayout
